<template>
<ContentWrapper>
    <div class="content-heading">
      <div>{{data.title}}</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          게시물 관리
        </li>
        <li class="breadcrumb-item active">
          <a :href="data.url">{{data.title}}</a>
        </li>
      </ol>
    </div>
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="search"/>
          <!-- 분류 -->
          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">채널</label>
            </div>
            <div class="col-auto">
              <b-input-group class="mt-2 mb-1">
                <div class="form-check mb-2">
                  <input class="form-check-input" :id="`user-type-all`" v-model="data.selectAllUserType"
                    value="" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-all`">전체</label>
                </div>
                <div v-for="(item, index) in warnUserTypes.array" :key="index" class="form-check mb-2 ml-3">
                  <input class="form-check-input" :id="`user-type-${index}`" v-model="data.selectedUserTypes" 
                    :value="item.value" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-${index}`">{{item.text}}</label>
                </div>
              </b-input-group>
            </div>

            <div class="col-auto">
              <label class="col-form-label">게시글 구분</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="data.topicOption.array" v-model="data.params.topicCd" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div class="col-auto">
              <label class="col-form-label">처리상태</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="warnStatusOption.array" v-model="data.params.statusCd" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>
          </div>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" style="width:100%"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        
        <span class="text-bold h4">목록</span>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center">No</td>
              <td width="5%" style="text-align:center" >채널</td>
              <td width="10%" style="text-align:center" >구분</td>
              <td style="text-align:center" @click="localSort.sort('title')" >대상 게시물<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="5%" style="text-align:center" @click="localSort.sort('writerId')">작성자<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="15%" style="text-align:center" @click="localSort.sort('report')">신고내용<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="5%" style="text-align:center" @click="localSort.sort('reporterId')">신고자<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="10%" style="text-align:center" @click="localSort.sort('regDt')">신고일<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" >처리여부</td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center" @click="doEdit(index)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center" @click="doEdit(index)">{{warnUserTypes.getText(item.typeCd)}}</td>
                <td class="align-middle text-center" @click="doEdit(index)">{{data.topicOption.getText(item.topicCd)}}</td>
                <td class="align-middle text-center" @click="doEdit(index)">{{item.title}}</td>
                <td class="align-middle text-center" @click="doEdit(index)">{{item.writerId}}</td>
                <td class="align-middle text-center" @click="doEdit(index)">{{item.report}}</td>
                <td class="align-middle text-center" @click="doEdit(index)">{{item.reporterId}}</td>
                <td class="align-middle text-center" @click="doEdit(index)">{{item.regDt}}</td>
                <td class="align-middle text-center">
                  <b-form-select :options="warnStatusOption.noEmptyArray" v-model="item.statusCd" @change="updateStatus(index);" class="custom-select custom-select-sm"></b-form-select>
                </td>
              </tr>
              <tr v-show="data.itemEditStatus[index].isEdit" :key="`${index}_1`">
                <td v-if="type=='warnList'" class="align-middle text-center" colspan="5">
                  <input type="text" v-model="item.statusComment" :class="{' form-control':true, 'is-invalid': errors.has('statusComment')}"  v-validate="''"  name="statusComment" style="width: 100%"  />
                </td>
                <td v-else class="align-middle text-center" colspan="5">
                  <b-button class="btn btn-b btn-danger mr-2" variant="info" @click="updateCmmtStatus(index)">{{data.cmmtStatusCds.getText(item.cmmtStatusCd)}}</b-button>
                  <b-button class="btn btn-b btn-dark mr-2" variant="info" @click="deleteCmmt(index)">삭제</b-button>
                  <b-button class="btn btn-b btn-info mr-2" variant="info" @click="clickedAddComment(index)">답글달기</b-button>
                </td>

                <td class="align-middle text-center" colspan="2">{{item.writerSendDt}}</td>
                <td class="align-middle text-center" colspan="2">
                  <b-button class="btn btn-b btn-danger mr-2" variant="info" @click="goDetail('writer', index)">작성자에게 이메일</b-button>
                </td>
              </tr>
              <tr v-show="data.itemEditStatus[index].isEdit" :key="`${index}_2`">
                <td v-if="type=='warnList'" class="align-middle text-center" colspan="5">
                  <b-button class="btn btn-b btn-info mr-2" variant="info" @click="updateStatusComment(index)">관리자 메모 (처리기록)</b-button>
                </td>
                <td v-else class="align-middle text-center" colspan="5">
                  <div v-show="data.itemEditStatus[index].addComment" class="td-row">
                    <input type="text" v-model="item.adminComment" :class="{' form-control':true, 'is-invalid': errors.has('adminComment')}"  
                      placeholder="관리자 답글을 입력하세요."
                      v-validate="'required|min:3'"  name="adminComment" style="width:80%"/>
                    <b-button class="btn btn-b btn-info ml-2" variant="info" @click="addComment(index)">등록</b-button>
                  </div>
                </td>

                <td class="align-middle text-center" colspan="2">{{item.reporterSendDt}}</td>
                <td class="align-middle text-center" colspan="2">
                  <b-button class="btn btn-b btn-info mr-2" variant="info" @click="goDetail('reporter', index)">신고자에게 이메일</b-button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, warnUserTypes, ValueTexts, warnTopicOption, warnCommentTopicOption, warnStatusOption} from "@/utils/Constants";
import {getWarnList, updateWarnItem, getWarnCommentList, updateCommentStatus, deleteComment, registerComment} from "@/api/community/CommunityAPI";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {SchDateRange, SchText, ShowCounter, Pagenation, Loading},
    props: {
      type:{
        type:String,
        default:'warnList' // 'warnList':신고 게시글, 'warnCommentList' : 신고 댓글
      }
    },
    setup(props, {root}) {
      const isTest = false;
      const modalLoading = ref(false);

      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.selectedUserTypes = warnUserTypes.array.map((item) => item.value);
      _dataObject.itemEditStatus = [];
      _dataObject.selectAllUserType = computed({
        get() {
          return data.selectedUserTypes.length == warnUserTypes.array.length;
        },
        set(newValue) {
          if (newValue) {
            data.selectedUserTypes = warnUserTypes.array.map((item) => item.value);
          } else {
            data.selectedUserTypes = [];
          }
        }
      });
      const data = reactive(_dataObject);
      console.log('data.selectedUserTypes:', data.selectedUserTypes);
      
      data.topicOption = new ValueTexts([]);
      if (props.type == 'warnList') {
        data.topicOption.setArray(warnTopicOption.array);
      } else {
        data.topicOption.setArray(warnCommentTopicOption.array);
      }
      data.schOptions = [
        {value:'title', text:'대상 게시물'},
        {value:'writerId', text:'작성자'},
        {value:'report', text:'신고내용'},
        {value:'reporterId', text:'신고자'},
      ];
      data.cmmtStatusCds = new ValueTexts([
        {value:'374001', text:'비노출', data:{isShow:true}},  // 정상, 노출
        {value:'374002', text:'노출', data:{isShow:false}},  // 본인삭제, 비노출
        {value:'374003', text:'노출', data:{isShow:false}}, // 관리자 숨김, 비노출
        {value:'374004', text:'비노출', data:{isShow:true}},  // 신고접수, 노출
      ]);

      const retVals = {
        isTest,
        modalLoading,
        warnUserTypes,
        warnStatusOption,
        data,
        ...methods(props, data),
        dataAction: new TableActionClass(data),
        localSort:root.$_localSort
      }

      methods(props, data).reset();

      onMounted(async () => {
        if (store.state.params.name == props.type) {
          const storedData = store.state.params.data;
          retVals.data.params = storedData.params;
          retVals.data.selectedUserTypes = storedData.userTypes;
          store.commit('setParams', {name:'', data:undefined});
        }
        await retVals.search();
      });
      watch(() => props.type, async (params, oldParams) => {
        console.log(`watch:${oldParams} => ${params}`);
        await retVals.resetSearch();
      });

      return retVals;
    }
}

function methods(props, data) {

  // 조건 리셋후 검색
  async function resetSearch() {
      await this.reset();
      await this.search();
  }

  function reset() {
    console.log('reset:', props, data);

    data.selectedUserTypes = warnUserTypes.array.map((item) => item.value);
    if (props.type == 'warnList') {
        data.title = '신고 게시글 관리';
        data.url = '/community/warnList';
        data.topicOption.setArray(warnTopicOption.array);
      } else {
        data.title = '신고 댓글 관리';
        data.url = '/community/warnCommentList';
        data.topicOption.setArray(warnCommentTopicOption.array);
      }
      data.params.typeCd = '';
      data.params.topicCd = '';
      data.params.statusCd = '';
      data.params.schType = '';
      data.params.schText = '';
  }

  // 목록
  async function search(page) {
    console.log('search:', data);

    if (!isNaN(page)) {
      data.params.page = page;
    }

    // typeCd 설정
    if (data.selectedUserTypes.length == 1) {
      data.params.typeCd = data.selectedUserTypes[0];
    } else {
      // length == 2 인 경우에도 '' 로 해서 전체 검색으로 전달한다.
      data.params.typeCd = '';
    }

    let result = undefined;
    if (props.type == 'warnList') {
      result = await getWarnList(data.params, this.isTest);
    } else {
      result = await getWarnCommentList(data.params, this.isTest);
    }
    data.list = result.data;
    data.count = result.count;
    this.localSort.set(data.list);

    data.itemEditStatus.splice(0, data.itemEditStatus.length);
    for (let i = 0; i < data.list.length; i++) {
      data.itemEditStatus.push({isEdit:false, addComment:false});
    }
    console.log('search itemEditStatus:', data.itemEditStatus);
  }

  // 공통 : 편집(메모작성 및 이메일 보내기)
  async function doEdit(index) {
    const item = data.itemEditStatus[index];
    if (item.isEdit) {
      item.isEdit = false;
      item.addComment = false;
    } else {
      data.itemEditStatus.forEach(item => {
        item.isEdit = false;
        item.addComment = false;
      });
      item.isEdit = true;
    }
  }

  // 공통: 상태 변경
  async function updateStatus(index) {
    const item = data.list[index];
    const params = {
      warnSeq : item.warnSeq,
      statusCd : item.statusCd,
      topicCd : item.topicCd,
      objectSeq : item.objectSeq
    }
    try {
      const result = await updateWarnItem(params, this.isTest);
      alert('변경되었습니다.');
    } catch (e) {
      alert(`변경 실패했습니다.:${e.message}`);
    } finally {
      this.search();
    }
  }

  // 신고 게시글 : 상태 메모 수정
  async function updateStatusComment(index) {
    const item = data.list[index];
    const params = {
      warnSeq : item.warnSeq,
      statusComment : item.statusComment
    }
    try {
      const result = await updateWarnItem(params, this.isTest);
      alert('변경되었습니다.');
    } catch {
      alert('변경 실패했습니다.');
    } finally {
      this.search();
    }
  }

  // 신고 댓글 : 관리자 댓글 입력창 보여주기
  function clickedAddComment(index) {
    const editItem = data.itemEditStatus[index];
    editItem.addComment = !editItem.addComment;
  }

  // 신고 댓글 : 답글 등록
  async function addComment(index) {
    const isValid = await this.$validator.validate('adminComment');
    if (!isValid) {
      alert ('답글이 유효하지 않습니다.');
      return;
    }
    const item = data.list[index];
    const params = {
      parentSeq : item.cmmtSeq,
      topicCd : item.topicCd,
      objectSeq : item.objectSeq,
      contents : item.adminComment,
    }
    const result = await registerComment(params);
    alert('답글이 등록되었습니다.');
  }

  // 신고 댓글 : 삭제
  async function deleteCmmt(index) {
    if (!confirm('댓글을 삭제하시겠습니까?')) {
      return;
    }
    const item = data.list[index];
    const params = {
      cmmtSeq : item.cmmtSeq,
      warnSeq : item.warnSeq
    }
    const result = await deleteComment(params);
    alert('삭제했습니다.');
    await this.search();
  }

  // 신고 댓글 : 댓글의 '노출', '비노출' 상태 변경
  async function updateCmmtStatus(index) {
    const item = data.list[index];
    const statusData = data.cmmtStatusCds.getData(item.cmmtStatusCd);
    const showStr = statusData.isShow ? '비노출' : '노출';
    if (!confirm(`댓글을 ${showStr}로 바꾸시겠습니까?`)) {
      return;
    }

    const newCmmtStatusCd = statusData.isShow ? '374003' : '374001';
    const params = {
      cmmtSeq : item.cmmtSeq,
      cmmtStatusCd : newCmmtStatusCd
    }
    const result = await updateCommentStatus(params);
    item.cmmtStatusCd = newCmmtStatusCd;
    alert('변경되었습니다.');
  }

  // 상세
  async function goDetail(emailType, index){
    this.$store.commit('setParams', {name:props.type, data:{userTypes:data.selectedUserTypes, params:data.params}});

    const item = data.list[index];
    if (emailType == 'writer') {
      item.name = item.writerName;
      item.email = item.writerEmail;
    } else { // reporter
      item.name = item.reporterName;
      item.email = item.reporterEmail;
    }

    if (props.type == 'warnList') {
      item.backTitle = '신고 게시글 관리';
      item.backUrl = '/community/warnList';
    } else {
      item.backTitle = '신고 댓글 관리';
      item.backUrl = '/community/warnCommentList';
    }
    this.$store.commit('setDetail', {
      name:'sendEmail',
      data: item
    });
    this.$router.push({name:`${props.type}_sendEmail`});
  }

  function list() {
    this.search();
  }

  return {
    resetSearch,
    reset,
    search,
    doEdit,
    updateStatus,
    updateStatusComment,
    updateCmmtStatus,
    deleteCmmt,
    clickedAddComment,
    addComment,
    goDetail,
    list,
  }
}
</script>